




































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import LayoutModule from '../../store/layout';

@Component<Header>({
    components: {},
})
export default class Header extends Vue {

    @Resolve
    public layout!: LayoutModule;


    public get headerLogoOmniSrc() {
            return this.layout.configuration.images.header || this.$settings.url(this.$settings.headerLogoOmni);
    }

    public get headerLogoOmnitropeSrc() {
            return this.layout.configuration.images.header || this.$settings.url(this.$settings.headerLogoOmnitrope);
    }
    public get isScrolling() {
        return this.layout.configuration.headerStyle === 'scrolling';
    }
}
